var _path, _path2, _path3, _line, _g, _line2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 76,
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 59.4872V65.7201H13.9834V70.9143C13.9834 71.4882 14.4483 71.9531 15.0223 71.9531H21.2553C21.8292 71.9531 22.2941 71.4882 22.2941 70.9143V65.7201H51.3813V70.9143C51.3813 71.4882 51.8462 71.9531 52.4201 71.9531H58.6531C59.2271 71.9531 59.692 71.4882 59.692 70.9143V65.7201H63.8473V59.4872H9.82812Z",
    fill: "#78C15A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5647 42.8658C27.8455 42.8658 26.4482 44.2631 26.4482 45.9823V57.4098H47.2248V45.9823C47.2248 44.2631 45.8276 42.8658 44.1083 42.8658H29.5647ZM45.1475 55.3318H28.5262V53.2541H45.1475V55.3318ZM45.1475 51.1765H28.5262V49.0988H45.1475V51.1765ZM45.1475 47.0212H28.5262V44.9435H45.1475V47.0212Z",
    fill: "#78C15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3722 45.9827C24.3722 43.1181 26.7018 40.7886 29.5664 40.7886H44.11C46.9746 40.7886 49.3041 43.1181 49.3041 45.9827V57.4102H61.7701V49.0995C61.7701 46.8037 59.9106 44.9442 57.6148 44.9442V12.8133L60.7364 10.733V5.46875L54.384 9.97205C53.8049 10.3564 53.4595 11.0057 53.4595 11.7017V22.09C53.4595 18.6463 50.6702 15.857 47.2265 15.857H26.4499C23.0373 15.857 20.2714 18.5996 20.2221 21.9991L20.2195 11.7019C20.2195 11.0059 19.8715 10.3593 19.2949 9.97225L12.9451 5.46895V10.7332L16.0668 12.8135V44.9444H16.0616C13.7658 44.9444 11.9062 46.8039 11.9062 49.0997V57.4104H24.3722L24.3722 45.9827ZM57.6148 49.0992V53.2545H51.3818V49.0992H57.6148ZM37.8767 26.2449H51.3811V34.5556H37.8767V26.2449ZM22.2939 53.2545H16.0609V49.0992H22.2939V53.2545ZM22.2939 26.2449H35.7984V34.5556H22.2939V26.2449Z",
    fill: "#78C15A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 64,
    x2: 77,
    y2: 10,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0007 10.8283L72.0509 15.7781L70.6367 14.3639L77.0007 7.9999L83.3646 14.3639L81.9504 15.7781L77.0007 10.8283Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0007 10.8283L72.0509 15.7781L70.6367 14.3639L77.0007 7.9999L83.3646 14.3639L81.9504 15.7781L77.0007 10.8283Z",
    fill: "#78C15A"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 5,
    x2: 90,
    y2: 5,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9993 63.1717L81.9491 58.2219L83.3633 59.6361L76.9993 66.0001L70.6354 59.6361L72.0496 58.2219L76.9993 63.1717Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9993 63.1717L81.9491 58.2219L83.3633 59.6361L76.9993 66.0001L70.6354 59.6361L72.0496 58.2219L76.9993 63.1717Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24,
    y2: -1,
    transform: "matrix(1 -4.37114e-08 -4.37114e-08 -1 67 67)",
    stroke: "#78C15A",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 65 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 89 50)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 89 50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTHeight);
export default __webpack_public_path__ + "static/media/T-HEIGHT.a7f068c0db3ddeaf62cebfaa65e22edf.svg";
export { ForwardRef as ReactComponent };